function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define("@asctech/vue-osu-navbar", [], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["@asctech/vue-osu-navbar"] = e() : t["@asctech/vue-osu-navbar"] = e();
}(window, function () {
  return a = {}, r.m = n = [function (t, e, n) {
    "use strict";

    n.r(e);
    var a = n(1),
        r = n.n(a);

    for (var s in a) {
      "default" !== s && function (t) {
        n.d(e, t, function () {
          return a[t];
        });
      }(s);
    }

    e["default"] = r.a;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e["default"] = void 0;
    var a = {
      props: {
        light: {
          type: Boolean,
          "default": !1
        }
      }
    };
    e["default"] = a;
  }, function (t, e, n) {}, function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return a;
    }), n.d(e, "b", function () {
      return r;
    });

    var a = function a(t, e) {
      var n = e._c;
      return n("div", e._g(e._b({
        "class": {
          "osu-navbar": !0,
          "osu-navbar--light": e.props.light
        },
        attrs: {
          id: "osu-navbar",
          role: "navigation",
          "aria-labelledby": "osu-navbar-heading"
        }
      }, "div", e.data.attrs, !1), e.listeners), [n("h2", {
        staticClass: "osu-semantic osu-navbar__title",
        attrs: {
          id: "osu-navbar-heading"
        }
      }, [e._v("\n    Ohio State Nav Bar\n  ")]), e._v(" "), n("a", {
        staticClass: "osu-semantic osu-navbar__skip",
        attrs: {
          href: "#page-content",
          id: "skip"
        }
      }, [e._v("\n    Skip to Main Content\n  ")]), e._v(" "), e._m(0)]);
    },
        r = [function (t, e) {
      var n = e._c;
      return n("div", {
        staticClass: "osu-navbar__container"
      }, [n("div", {
        staticClass: "osu-navbar__university-info"
      }, [n("p", {
        staticClass: "osu-navbar__university-info__name"
      }, [n("a", {
        attrs: {
          href: "https://osu.edu",
          title: "The Ohio State University"
        }
      }, [e._v("\n          The Ohio State University\n        ")])])]), e._v(" "), n("div", {
        staticClass: "osu-navbar__university-links"
      }, [n("nav", {
        staticClass: "osu-navbar__university-links__links"
      }, [n("ul", [n("li", [n("a", {
        staticClass: "osu-navbar__university-links__help",
        attrs: {
          href: "https://www.osu.edu/help"
        }
      }, [e._v("\n              Help\n            ")])]), e._v(" "), n("li", [n("a", {
        staticClass: "osu-navbar__university-links__buckeye-link",
        attrs: {
          href: "https://buckeyelink.osu.edu/"
        }
      }, [e._v("\n              BuckeyeLink\n            ")])]), e._v(" "), n("li", [n("a", {
        staticClass: "osu-navbar__university-links__map",
        attrs: {
          href: "https://www.osu.edu/map/"
        }
      }, [e._v("\n              Map\n            ")])]), e._v(" "), n("li", [n("a", {
        staticClass: "osu-navbar__university-links__find-people",
        attrs: {
          href: "https://www.osu.edu/findpeople"
        }
      }, [e._v("\n              Find People\n            ")])]), e._v(" "), n("li", [n("a", {
        staticClass: "osu-navbar__university-links__webmail",
        attrs: {
          href: "https://email.osu.edu/"
        }
      }, [e._v("\n              Webmail\n            ")])]), e._v(" "), n("li", [n("a", {
        staticClass: "osu-navbar__university-links__search",
        attrs: {
          href: "https://www.osu.edu/search/"
        }
      }, [e._v("\n              Search Ohio State\n            ")])])])])])]);
    }];
  }, function (t, e, n) {
    "use strict";

    function a(t, e, n, a, r, s, i, o) {
      var u,
          l = "function" == typeof t ? t.options : t;
      if (e && (l.render = e, l.staticRenderFns = n, l._compiled = !0), a && (l.functional = !0), s && (l._scopeId = "data-v-" + s), i ? (u = function u(t) {
        (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), r && r.call(this, t), t && t._registeredComponents && t._registeredComponents.add(i);
      }, l._ssrRegister = u) : r && (u = o ? function () {
        r.call(this, this.$root.$options.shadowRoot);
      } : r), u) if (l.functional) {
        l._injectStyles = u;
        var c = l.render;

        l.render = function (t, e) {
          return u.call(e), c(t, e);
        };
      } else {
        var _ = l.beforeCreate;
        l.beforeCreate = _ ? [].concat(_, u) : [u];
      }
      return {
        exports: t,
        options: l
      };
    }

    n.d(e, "a", function () {
      return a;
    });
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var a = n(3),
        r = n(0);

    for (var s in r) {
      "default" !== s && function (t) {
        n.d(e, t, function () {
          return r[t];
        });
      }(s);
    }

    n(6);
    var i = n(4),
        o = Object(i.a)(r["default"], a.a, a.b, !0, null, null, null);
    e["default"] = o.exports;
  }, function (t, e, n) {
    "use strict";

    var a = n(2);
    n.n(a).a;
  }], r.c = a, r.d = function (t, e, n) {
    r.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var a in e) {
      r.d(n, a, function (t) {
        return e[t];
      }.bind(null, a));
    }
    return n;
  }, r.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t["default"];
    } : function () {
      return t;
    };
    return r.d(e, "a", e), e;
  }, r.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, r.p = "/dist/", r(r.s = 5);

  function r(t) {
    if (a[t]) return a[t].exports;
    var e = a[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return n[t].call(e.exports, e, e.exports, r), e.l = !0, e.exports;
  }

  var n, a;
});